import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TestlistService } from '@app-services/test/testlist.service';

@Component({
  selector: 'app-overallpaper',
  templateUrl: './overallpaper.component.html',
  styleUrls: ['./overallpaper.component.css']
})
export class OverallpaperComponent implements OnInit {
  OverallpaperUtility:any={
    paperDropdownList:[],
    selectedReportPaper:'all'
  }
  constructor(
    private testListService: TestlistService,

  ) { }
@Input('examinfo') examinfo:any;
@Output('paperChangeEvent')paperChangeEvent = new EventEmitter()

  ngOnInit(): void {
    this.InitalizeDropdown()
  }
  ngOnChanges(){

  }
InitalizeDropdown(){
this.OverallpaperUtility.paperDropdownList = this.testListService.getUSerExamlist?.completedTests?.filter(v=>(v.subruleid == this.examinfo?.subruleid)&& v.status =="COMPLETED")
this.OverallpaperUtility.selectedReportPaper =this.testListService.selectedReportPaper||'all'   
}
paperSelectionChange(event){
this.paperChangeEvent.emit({selectedPaper: event.value =='all'?this.examinfo?.subruleid : event.value})
}
}
